export const onClick = (onClick, tabIndex) =>
  onClick
    ? {
        onClick,
        onKeyPress: (e, ...params) =>
          e.code === 'Enter' && onClick(e, ...params),
        tabIndex: tabIndex || null,
      }
    : {};
